import React from 'react';
import PropTypes from 'prop-types';
import { DateTimePicker } from 'react-widgets';
import Globalize from 'globalize';
import globalizeLocalizer from 'react-widgets-globalize';
import 'react-day-picker/lib/style.css';
import styles from './styles.scss';

// Localize for DateTimePicker
globalizeLocalizer(Globalize);


const propTypes = {
  time: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  min: PropTypes.object,
  max: PropTypes.object,
  format: PropTypes.string
};

class DatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      containerClassName: styles.container
    };

    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }
  get minValue() {
    return this.props.min || new Date(1900, 0, 1);
  }

  get maxValue() {
    return this.props.max || new Date();
  }

  onFocus() {
    this.setState({
      containerClassName: `${styles.container} ${styles.containerFocus}`
    })
  }

  onBlur() {
    this.setState({
      containerClassName: styles.container
    })
  }

  render() {
    const {
      onChange,
      placeholder,
      value,
      min,
      max,
      time,
      format
    } = this.props;
    const { containerClassName } = this.state;
    return (
      <DateTimePicker
        time={time}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        containerClassName={containerClassName}
        max={this.maxValue}
        min={this.minValue}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        format={format}
      />
    );
  }
}

DatePicker.propTypes = propTypes;

export default DatePicker;


// WEBPACK FOOTER //
// src/components/shared/DatePicker/index.jsx